import 'bootstrap';
import { useEffect } from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { appConfigs } from '../bootstrap//config';

// Components
import { routes } from '@app/App.routing';
import { RouterOutlet } from '@bootstrap/router';
//import { SpriteIcon } from './components';

//Styling
import './App.scss';

// Setup localization
import { langResources } from '@app/assets/locales';

import TagManager from 'react-gtm-module';

export const App = (): JSX.Element => {
  useEffect(() => {
    i18n.use(initReactI18next).init({
      resources: langResources,
      fallbackLng: localStorage.getItem('lang') || appConfigs['APP_DEFAULT_LOCALE'],
    });
  }, []);

  function showCookieFail() {
    if (!navigator.cookieEnabled) {
      document.write(`<h1>請接受cookie以繼續瀏覽本網站</h1>`);
    }
  }
  showCookieFail();

  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM_TRACKING_ID || '',
    // dataLayer: {
    //     userId: '001',
    //     userProject: 'project'
    // }
  }
  
  TagManager.initialize(tagManagerArgs)

  return (
    <div className="app">
      <RouterOutlet routes={routes} />
    </div>
  );
};
